<template>
  <Layout>
    <template>
      <router-view :key="key"></router-view>
    </template>
    <template slot="bottom">
      <BottomMenu />
    </template>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import BottomMenu from "@/components/BottomMenu";

export default {
  components: {
    Layout,
    BottomMenu,
  },
  computed: {
    key() {
      return Math.random()
    }
  }
};
</script>

<style>
</style>